import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
	root: {
		color: "black",
		width: "100%",
		paddingBottom: "5px",
		fontWeight: "bold"
	},
});

export default useStyles;